import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import UserInfoService from "services/AccountInfo/";
import Day from 'dayjs';
import StorageService from 'services/StorageService';
import Link  from 'components/Link';
import Loader from 'components/Loader';
import { actionsType, consumer } from 'config/constants'
import { termsConditionsText } from 'config/translate/variables';
import PubSub from 'services/PubSub';
import style from './style.scss'; //NOSONAR

const TermsAndConditions = ({close}) => {
    const [checked, setChecked] = useState(true);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        enableSubmit(true)
    }, [])


    const onChange = (event) => {
        if(event.target.checked) {
            setChecked(true);
            enableSubmit(true);
        } else {
            setChecked(false);
            enableSubmit(false);
        }

    }

    const click = () => {

        const consumer = validateConsumer();

        if(checked) {
            setLoading(true);
            UserInfoService.updateUser(consumer).then(() => {
                let data = StorageService.getSecureItem('userData');
                data.termsAcceptanceDate = consumer.termsAcceptanceDate;
                StorageService.setSecureItem('userData', data);
                setLoading(false);
                setTimeout(() => {
                    close();
                }, 500);
            })
        }
    }

    const validateConsumer = () => {

        let terms = {
            termsAcceptanceDate : {}
        };

        if(consumer.includes('santaisabel')){
            return  { ...terms, termsAcceptanceDate: {sisa : Day().format()} }
        }

        return  { ...terms, termsAcceptanceDate: {jumbo : Day().format()} }
    }

    const enableSubmit = (value) =>{
        PubSub.dispatch(actionsType.CHECKOUT_ENABLE_SUBMIT, {active: value})
    }


    return (
        <div className='new-modal-container terms-and-conditions'>
            <div className="new-modal-title-wrap"><h1 className="new-modal-title">{termsConditionsText.title}</h1></div>
            <div className={'new-modal-scroll'}>
                <h3 className="terms-and-conditions-subtitle">{termsConditionsText.subTitle}</h3>
                <p className="terms-and-conditions-paragraph">{termsConditionsText.firstParagraph}</p>
                {termsConditionsText.secondParagraph && <p className="terms-and-conditions-paragraph last-paragraph-terms">{termsConditionsText.secondParagraph}</p>}
                {termsConditionsText.thirdParagraph && <p className="terms-and-conditions-paragraph last-paragraph-terms">{termsConditionsText.thirdParagraph}</p>}
                {termsConditionsText.fourParagraph && <p className="terms-and-conditions-paragraph last-paragraph-terms">{termsConditionsText.fourParagraph}</p>}
                {termsConditionsText.lastParagraph &&<p className="terms-and-conditions-paragraph last-paragraph-terms">{termsConditionsText.lastParagraph}</p>}
            </div>
            <div className="modal-actions">
                <label className="terms-and-conditions-cont-check">
                    <input type="checkbox" name='terms-and-conditions' checked={checked} onChange={(event) => onChange(event)}/>    
                    <span className="terms-and-conditions-accept">Acepto los nuevos los <Link target={"_blank"} to="/institucional/terminos-condiciones" className="new-link new-link-small terms-and-conditions-link">Términos y condiciones</Link></span>
                </label>
                
                <button className={checked ? "primary-btn" : "disabled-btn"} onClick={click}>
                    {!isLoading && 'Confirmar'}
                    {isLoading && <span className="terms-and-conditions-loader"><Loader/></span>}
                </button>
            </div>
        </div>
    )
}

TermsAndConditions.propTypes = {
    close: PropTypes.func
}

export default TermsAndConditions;
